export default [
  {
    CouponName: "Coupon 1",
    coupondiscount: "10%",

    couponcode: "ABC123",

    Limit: "100",
    StartDate: "8/7/2021",
    EndDate: "8/8/2021",
    usage: "10",
    Status: "Active"
  }
];
